<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>부서 관리</h1>
                    </div>
                </div>
            </div>            
        </div>        
        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">필요한 내용 쓸것</strong>
                </div>
                <b-card-body>
                    <div class="mb-1 mt-2 float-left">
                        <b-button class="mb-2" size="" variant="primary" @click="showAddDepartmentForm">부서등록</b-button>
                    </div>
                    <b-table 
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        fixed="fixed"
                        responsive="sm" 
                        :small="true"                          
                        :striped="false" 
                        :bordered="true"  
                        hover                                 
                        :items="items" 
                        :fields="fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :filter="filter"
                        @filtered="onFiltered"
                        @row-clicked="detailDepartment">
                        <template slot="regEmployees" slot-scope="row">
                            <b-button size="sm" @click.stop="regEmployees(row.item)" class="mr-1">
                            직원 등록
                            </b-button>
                        </template>                                                              
                    </b-table>
                    <b-pagination size="md" align="center" :total-rows="totalRows" :limit="10" :hide-ellipsis="true" :per-page="perPage" v-model="currentPage" /> 
                </b-card-body>
            </div>
            <b-modal id="employee-pop" 
                ref="departmentDetail" 
                centered 
                title="부서 정보"
                :ok-title="isModify ? '수정' : '등록'"
                cancel-title="취소"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                @hidden="initDepartmentForm"
                @ok="isModify ? updateDepartmentInfo($event) : addDepartment($event)">
                <b-card v-if="department != null">
                <b-form>
                    <b-form-group
                        label="부서명(필수)"                                    
                        label-for="deptName"                                    
                        :label-cols="3"
                        :horizontal="true">
                        
                        <b-form-input id="deptName" type="text" placeholder="부서명" 
                                    v-model="department.deptName"
                                    data-vv-delay="500"
                                    data-vv-name="deptName"
                                    v-validate="'required|max:10'">                                    
                        </b-form-input>
                        <span v-show="errors.has('name')" class="text-danger">* 부서명을 입력해주세요({{ errors.first('deptName') }})</span>
                    </b-form-group>
                    <b-form-group
                        label="한도초과시 접수가능여부"
                        label-for="overLimitPermitYN"
                        :label-cols="6"
                        :horizontal="true">
                            <b-form-radio-group
                            id="overLimitPermitYN"
                            name="overLimitPermitYN">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="overLimitPermitY" name="overLimitPermitYN" class="custom-control-input" value="Y" v-model="department.limitOption.overLimitPermitYN">
                                <label class="custom-control-label" for="overLimitPermitY">허용</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="overLimitPermitN" name="overLimitPermitYN" class="custom-control-input" value="N" v-model="department.limitOption.overLimitPermitYN">
                                <label class="custom-control-label" for="overLimitPermitN">허용안함</label>
                            </div>                                    
                            </b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                        label="한도횟수"
                        label-for="useLimitCnt"                                    
                        :label-cols="5"
                        :horizontal="true">
                        <b-form-input id="useLimitCnt" type="number" placeholder="한도횟수" v-model="department.limitOption.useLimitCnt" ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        label="한도금액"
                        label-for="useLimitAmount"                                    
                        :label-cols="5"
                        :horizontal="true">
                        <b-form-input id="useLimitAmount" type="number" placeholder="한도금액" v-model="department.limitOption.useLimitAmount"></b-form-input>
                    </b-form-group>
                </b-form>
                </b-card>
            </b-modal>
        </b-container>    
    </div>
</template>
<script>
import {department} from '../data/table.js'
import ResultMessage from '../data/resultMessage'
import departmentApi from '../api/department'
import {mapGetters} from 'vuex'
import _ from 'lodash'

export default {
    name: 'mngrDepartment',
    data() {
        return {
            fields: department.fields,
            items: [],            
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            filter: null,
            department: null,
            isModify: false
        }
    },
    computed: mapGetters({
        userAccount: 'userAccount/userAccount'                
    }),
    methods: {
        initDepartement: function() {
            return {
                clientGroupNo: this.userAccount.corpNo,
                deptName: null,
                limitOption: {
                    overLimitPermitYN: 'Y',
                    useLimitCnt: null,
                    useLimitAmount: null
                }
            }
        },
        showAddDepartmentForm : function() {
            this.department = this.initDepartement();
            this.$refs.departmentDetail.show();
        },
        addDepartment: function(event) {
            event.preventDefault();
            if(this.department == null) {
                alert('등록할 내용이 없습니다.');
                return;
            }
            if(confirm('등록하시겠습니까?') == false ) return;

            this.$validator.validateAll()
            .then(success => {
                if(success == false) {
                    alert('필수 항목을 입력해 주세요');
                    return;
                }
                let resultMessage = new ResultMessage();
                this.department.corpNo = this.userAccount.corpNo;
                departmentApi.addDepartment(this.department).then(response => {                    
                    alert('등록 되었습니다.');
                    this.departmentList();
                    this.$refs.departmentDetail.hide();
                }).catch(error => {
                    resultMessage.buildErrorMessage(error);
                    alert(resultMessage.message);
                })
            })
        },
        updateDepartmentInfo: function(event) {
            event.preventDefault();
            if(this.department == null) {
                alert('변경할 내용이 없습니다.')
                return;
            }

            if(confirm('변경하시겠습니까?') == false) return;
            let resultMessage = new ResultMessage();

            this.$validator.validateAll()
            .then(success => {
                if(success == false) {
                    alert('필수 항목을 모두 입력해주세요');
                    return;
                }
                departmentApi.modifyDepartment(this.department).then(response => {
                    alert('변경되었습니다.');                    
                    this.$refs.departmentDetail.hide();                    
                    this.departmentList();
                }).catch(error => {
                    resultMessage.buildErrorMessage(error);
                    alert(resultMessage.message);
                })
            })
        },
        detailDepartment: function(item, index, event) {
            let resultMessage = new ResultMessage();         
            departmentApi.departmentInfo(this.userAccount.corpNo, item.pid).then(response => {
                resultMessage.buildSuccessMessage(response);
                this.department = resultMessage.payload;      

                this.isModify = true;
                this.$refs.departmentDetail.show();                          
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        },
        departmentList: function() {
            let resultMessage = new ResultMessage();         
            departmentApi.departmentList(this.userAccount.corpNo).then(response => {
                resultMessage.buildSuccessMessage(response);
                this.items = resultMessage.payload;                                
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        },
        initDepartmentForm: function() {
            this.department = null;
            this.isModify = false;
        },
        onFiltered: function() {

        },
        currencyFormatter : function (params) {
            return this.formatNumber(params);
        },
        regEmployees(item) {
            
            this.$router.push({path : 'regEmployees', query: {deptNo: item.pid}});
        }              
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        this.departmentList();
    }

}
</script>




// WEBPACK FOOTER //
// src/components/MngrDepartment.vue